import React from 'react'
import { Checkbox } from '@/components/ui/checkbox'
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'

interface FilterAccordionProps {
  title: string
  options: { id: string; label: string }[]
  singleSelect?: boolean
  selectedValue?: string
  onSelectionChange?: (value: string) => void
  selectedValues?: string[]
  onMultiSelectionChange?: (value: string) => void
  defaultOpen?: boolean
}

export const FilterAccordion = ({
  title,
  options,
  singleSelect = false,
  selectedValue,
  onSelectionChange,
  selectedValues,
  onMultiSelectionChange,
  defaultOpen = true,
}: FilterAccordionProps) => {
  const handleCheckboxChange = (optionId: string) => {
    if (singleSelect && onSelectionChange) {
      if (selectedValue === optionId) {
        onSelectionChange('')
      } else {
        onSelectionChange(optionId)
      }
    } else if (onMultiSelectionChange) {
      onMultiSelectionChange(optionId)
    }
  }

  const isChecked = (option: { id: string }) => {
    if (singleSelect) {
      return option.id === selectedValue
    }
    return selectedValues?.includes(option.id) || false
  }

  return (
    <Accordion
      type="single"
      collapsible
      className="border-b border-gray-300"
      defaultValue={defaultOpen ? title : undefined}
    >
      <AccordionItem value={title} className="border-b-0">
        <AccordionTrigger className="py-3 text-sm sm:text-base font-bold cursor-pointer">
          {title}
        </AccordionTrigger>
        <AccordionContent>
          <div className="space-y-2.5 pb-2">
            {options.map((option) => (
              <div key={option.id} className="flex items-center space-x-2">
                <Checkbox
                  className="rounded-none border-gray-500 cursor-pointer [&[data-state=checked]]:bg-white [&[data-state=checked]]:text-black [&[data-state=checked]]:border-gray-500"
                  id={option.id}
                  checked={isChecked(option)}
                  onCheckedChange={() => handleCheckboxChange(option.id)}
                />
                <label
                  htmlFor={option.id}
                  className="text-sm pl-2 leading-none cursor-pointer peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                >
                  {option.label}
                </label>
              </div>
            ))}
          </div>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  )
}
